import { useEffect, useState } from "react";
import api from "../api/axios";
import Swal from "sweetalert2";

function ServiceList() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      const response = await api.get("/Service/GetService");

      setServices(response.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to load services",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h4 className="mb-0">Service List</h4>
      </div>

      <div className="card-body">
        {loading ? (
          <div className="text-center">Loading...</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead className="table-dark">
                <tr>
                  <th>ID</th>
                  <th>Service Name</th>
                  <th>Prefix</th>
                  <th>Counter ID</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {services.length > 0 ? (
                  services.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.serviceName}</td>
                      <td>{item.prefix}</td>
                      <td>{item.counterId} {item.isActive}


  {/* {JSON.stringify(item.isActive)} */}

                      </td>
                      <td>
                      {item.isActive === true ? (
  <span className="badge bg-success">
  <i className="bi bi-eye-fill"></i>  Active
  </span>
) : (
  <span className="badge bg-danger">
   <i className="bi bi-eye-slash-fill"></i> Inactive
  </span>
)}
                        {/* {item.isActive ? "Active" : "Inactive"} */}
                        
                        </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default ServiceList;
